import { useState, useEffect, useCallback } from "react";
import { loadBatchFix, type BatchFixData } from "../api/batch-fix";

export function useBatchFix(id: string) {
  const [state, setState] = useState<BatchFixData | null>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    loadBatchFix(id)
      .then(setState)
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    load();
  }, [load]);

  const reload = useCallback(() => {
    return loadBatchFix(id).then(setState);
  }, [id]);

  return { state, loading, reload };
}
